

var sponsor = function( global, sponsorlogo) {
    var modalDiv = $('#'+ global.modal);

    $(modalDiv).on('hidden.bs.modal', function (e) {

        $(modalDiv).find('.modal-content').html('');
    });

    var modalcontentstr = '<div class="modal-header">Dermpath Study Tool Sponsored by:</div><div class="modal-body">' +
        '<div style="text-align:center;"><img src="'+sponsorlogo+'"></div>' +
        '</div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Begin</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);
    $(modalDiv).find('.modal-content').append(modalContent);

    $(modalDiv).modal();
}

module.exports = sponsor;


//////////////////
// WEBPACK FOOTER
// ./src/sponsorship.js
// module id = 323
// module chunks = 0